import React from 'react';

import Info from './info/Info';
import Investors from './investors/Investors';
import { Team } from './team/Team';
import { Timeline } from './timeline/Timeline';
import Career from './Career';
import Header from './Header';
import More from './More';

const AboutPage = () => (
    <>
      <Header />
      <Info />
      <Timeline />
      <Team />
      <Career />
      <Investors />
      <More />
    </>
);

export default AboutPage;
